export default __webpack_public_path__ + "media/color/bcbc-6335b921.svg";